"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessTokenType = void 0;
/**
 * Contains definitions for all currently supported types of process tokens.
 *
 * The type of token determines the point in time at which the token was recorded.
 */
var ProcessTokenType;
(function (ProcessTokenType) {
    ProcessTokenType["onEnter"] = "onEnter";
    ProcessTokenType["onSuspend"] = "onSuspend";
    ProcessTokenType["onResume"] = "onResume";
    ProcessTokenType["onExit"] = "onExit";
})(ProcessTokenType = exports.ProcessTokenType || (exports.ProcessTokenType = {}));
//# sourceMappingURL=ProcessToken.js.map